import { Link, useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  composeValidators,
  email,
  renderField,
  required,
  validatePassword,
} from "../../helpers/form-validations";
import { Field, Form } from "react-final-form";
import { EyeNoneIcon, EyeOpenIcon } from "@radix-ui/react-icons";
import React, { useState } from "react";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "../ui/input-otp";
import { CircleArrowLeft } from "lucide-react";
import { login, verifyOTP } from "../../utils/util";
import { useDispatch } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { alertDanger, alertSuccess } from "../../context/actions/toastAction";
import { setUserDetails } from "../../context/actions/userAction";

// Fix for accessibility issues. Issue # VII26-106
export const description =
  "A login page with two columns. The first column has the login form with email and password. There's a Forgot your password link and a link to sign up if you do not have an account. The second column has a cover image.";

export function OTPComponent({ onBack }) {
  const dispatch = useDispatch()
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (formData) => {
    dispatch(loaderSet(true))
    const loginPayload = {
      email: localStorage.getItem("email"),
      otp: formData.otp,
    };

    try {
      if (!formData.otp) {
        throw new Error("Required OTP")
      }
      const response = await verifyOTP(loginPayload);
      const payload = response?.data || response || {};
      const userData = payload?.data || payload || {};
      const userType = userData.user_type || payload.user_type || "investor";

      if (response?.code === 200 || response?.status === "success") {
        dispatch(setUserDetails(userData));
        if (userType === "admin") {
          navigate("/admin", { replace: true });
        } else if (userType === "investor") {
          navigate("/investor", { replace: true });
        } else if (userType === "employee") {
          navigate("/employee", { replace: true });
        } else if (userType === "distributor") {
          navigate("/distributor", { replace: true });
        } else {
          navigate("/investor", { replace: true });
        }
        dispatch(loaderSet(false));
        dispatch(alertSuccess("Successfully Logged In"));
      }
      else {
        formData.otp = null
        throw new Error("Invalid OTP or Expired OTP")
      }

    } catch (error) {
      // Log error for debugging
      dispatch(loaderSet(false))
      console.error("Error during login:", error);
      dispatch(alertDanger(error.message))
      //   setFormErrors({ general: 'An error occurred during login. Please try again.' });
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleResendOTP = async () => {
    dispatch(loaderSet(true))
    const email = localStorage.getItem("email")
    const password = localStorage.getItem("password")
    try {
      const loginPayload = {
        email: email ? email : "",
        password: password ? password : "",
      };
      const response = await login(loginPayload);
      if (response && response?.message) {
        dispatch(loaderSet(false))
        dispatch(alertSuccess("OTP Resend Successfully"))
      }
    } catch (error) {
      console.log("Error in Resend Otp")
    }
  }

  return (
    <>
      <div className="w-full  h-[100vh]  md:h-[100vh] lg:h-[100vh] xl:h-[100vh] 2xl:h-[100vh]">
        {/* Right side login */}

        {/* Accessiblity issue fixed - issues VII26-101 */}
        <main className="flex  justify-center py-16  h-[100%] text-black " aria-labelledby="otp-heading">
          <div className="mx-auto flex flex-col  w-full gap-16">
            <div className=" flex justify-center items-center w-full">
              {/* Accessiblity issue fixed - issues VII26-105 */}
              <Link to="/" aria-label="Vasuki India Home" className="rounded-md focus-visible:ring-2 focus-visible:ring-[#0D215C]">
                <img src="/vasuki-logo.svg" className="w-56" alt="Vasuki India logo" />
              </Link>
            </div>
            <Form
              onSubmit={onSubmit}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div className=" grid gap-2 pl-16 pr-16  ">
                    <div className="flex gap-4 pb-2 items-center text-[#0D215C] ">
                      {/* Accessiblity issue fixed - issues VII26-106 */}
                      <button
                        type="button"
                        onClick={onBack}
                        className="inline-flex items-center justify-center rounded-md focus-visible:ring-2 focus-visible:ring-[#0D215C]"
                        aria-label="Back to login"
                      >
                        <CircleArrowLeft className="size-6" aria-hidden="true" />
                      </button>
                      <div className="flex flex-col gap-0">
                        <h1 id="otp-heading" className="text-lg font-semibold">Enter OTP</h1>
                        <p className="text-sm">
                          Fill-in the 6-digit OTP you received in your email
                        </p>
                      </div>
                    </div>
                    <div className="grid gap-2">
                      <div className="grid grid-row gap-4 py-3">
                        <Label
                          className="text-start text-[#0D215C] font-bold text-lg"
                          htmlFor="otp"
                        >
                          OTP{" "}
                          <span className=" text-red-600 font-bold text-sm">
                            *
                          </span>
                        </Label>
                        <Field name="otp" id="otp">
                          {({ input }) => (
                            <InputOTP
                              maxLength={6}
                              {...input}

                            // className={`flex items-center gap-1 mb-4 justify-between  ${otpError && 'error'}`}
                            >
                              {[...Array(6)].map((_, index) => (
                                <React.Fragment key={index}>
                                  <InputOTPGroup>
                                    <InputOTPSlot
                                      index={index}
                                      className="bg-white border-[#3a5dd1]"
                                    // className={`flex justify-center w-16 h-12 2xl:w-24 2xl:h-16 text-lg  text-center bg-[#11141F] border ${otpError ? 'border-red-500' : 'border-[#34416D]'} rounded-md items-center`}
                                    />
                                  </InputOTPGroup>
                                  {index < 5 && (
                                    <span
                                    // className={`${otpError ? 'text-red-500' : 'text-[#34416D]'} text-2xl 2xl:text-5xl`}
                                    >
                                      -
                                    </span>
                                  )}
                                </React.Fragment>
                              ))}
                            </InputOTP>
                          )}
                        </Field>
                      </div>
                      {/* {formErrors.otp && (
                          <p className="text-red-500 text-base text-left mb-5">{formErrors.otp}</p>
                        )} */}
                    </div>

                    <div className="flex justify-between py-2  w-full">
                      <Button type="submit" className="w-[40%] bg-[#0D215C]">
                        Confirm & Login
                      </Button>
                      {/* Accessiblity issue fixed - issues VII26-107 */}
                      <div className=" text-[#0D215C] text-sm">
                        Didn't receive OTP?{" "}
                        <button
                          type="button"
                          onClick={handleResendOTP}
                          className="ml-auto inline-block text-[#0D215C] text-md font-semibold underline cursor-pointer rounded-md focus-visible:ring-2 focus-visible:ring-[#0D215C]"
                          aria-label="Resend one-time password"
                        >
                          Resend Now
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              )}
            />
          </div>
        </main>
      </div>
    </>
  );
}

export default OTPComponent;